// src/stores/globalFilterStore.ts
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export type GlobalMember = { id: string; name: string; image?: string | null } | null
export type GlobalBrand = { id: string; name: string; logo?: string | null }

interface GlobalFilterState {
  member: GlobalMember
  brands: GlobalBrand[]
  // Monotonic counter bumped on every user-driven change (setMember/setBrands/
  // reset). Pages compare it against the last version they applied: a change
  // means "the user just set the global filter" → re-apply to every page,
  // overriding any manual per-page edits made since the previous global change.
  version: number
  setMember: (m: GlobalMember) => void
  setBrands: (b: GlobalBrand[]) => void
  reset: () => void
}

export const useGlobalFilterStore = create<GlobalFilterState>()(
  devtools(
    persist(
      (set) => ({
        member: null,
        brands: [],
        version: 0,
        setMember: (member) => set((s) => ({ member, version: s.version + 1 })),
        setBrands: (brands) => set((s) => ({ brands, version: s.version + 1 })),
        reset: () => set((s) => ({ member: null, brands: [], version: s.version + 1 })),
      }),
      { name: 'global-filter-storage' }
    ),
    { name: 'GlobalFilterStore', enabled: import.meta.env.DEV }
  )
)
